var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("execution-level-legend", {
        attrs: {
          "legend-data": _vm.executionLevelArchieved,
          title: "Leyenda de Nivel de Ejecución Alcanzado"
        }
      }),
      _vm.goals.length == 0 && !_vm.isAddGoalMode
        ? _c(
            "div",
            { staticClass: "bg-secondary-13 p-3 rounded text-center" },
            [
              _c("action-button", {
                staticClass: "border btn px-5",
                attrs: {
                  i: "fas fa-file-plus color-green",
                  text: "Presione aquí para añadir metas"
                },
                on: { click: _vm.addItem }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.goals.length && !_vm.isAddGoalMode
        ? [
            _vm._l(_vm.goalsSorted, function(goal, idx) {
              return _c("div", { key: `goal-${idx}` }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "row mx-0 aling-items-center bg-secondary-3 rounded py-3 px-4 mb-3"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-10 d-flex flex-column" },
                      [
                        _c("div", { staticClass: "d-flex" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "badge badge-pill bg-secondary-2 px-3 d-flex align-items-center font-16 font-weight-bold color-white"
                            },
                            [_vm._v(" Meta #" + _vm._s(idx + 1) + " ")]
                          ),
                          goal.academicYear
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "badge badge-pill px-3 d-flex align-items-center font-16 font-weight-bold ml-3 color-black",
                                  style: {
                                    "background-color":
                                      goal.executionLevelArchieved?.color ||
                                      "#ccc"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        `${goal.academicYear?.description ??
                                          ""} - ${goal.executionLevelArchieved
                                          ?.name ?? ""}`
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center flex-md-row flex-column mt-2"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "font-weight-normal color-black flex-grow-1"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.computedDescription(goal)) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    !_vm.disabled
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-md-2 d-flex justify-content-end align-items-center"
                          },
                          [
                            _c("dropdown", {
                              staticClass: "actions-dropdown",
                              attrs: {
                                items: _vm.actionItems(goal, idx),
                                title: "Acciones"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ])
            }),
            !_vm.disabled
              ? _c(
                  "div",
                  { staticClass: "d-flex justify-content-end" },
                  [
                    _c("action-button", {
                      attrs: {
                        i: "fas fa-file-plus",
                        text: "Añadir",
                        variant: "success mt-2"
                      },
                      on: { click: _vm.addItem }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm.isAddGoalMode
        ? [
            _c(
              "custom-collapse",
              {
                staticClass: "intervention-plan-collapse mt-4 mx-md-3",
                attrs: { id: "meta-collapse" }
              },
              [
                _c(
                  "custom-collapse-item",
                  {
                    ref: _vm.accordionItems.academicYear.name,
                    staticClass: "border-bottom",
                    attrs: {
                      id: "collapse-item-academic-year",
                      "body-background-color": "#F7F7F7",
                      checked: _vm.accordionItems.academicYear.checked,
                      disabled: _vm.accordionItems.academicYear.disabled,
                      expanded: _vm.accordionItems.academicYear.expanded,
                      "parent-id": "meta-collapse",
                      selected: !_vm.accordionItems.academicYear.disabled,
                      title: "Año Académico"
                    }
                  },
                  [
                    _c("validation-observer", { ref: "academicYearForm" }, [
                      _c("div", { staticClass: "row d-flex" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-4" },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-drop-down", {
                                        staticClass: "pl-md-4",
                                        attrs: {
                                          "custom-error-msg":
                                            "El año escolar es requerido.",
                                          error: errors[0],
                                          fieldkey: "id",
                                          fieldname: "description",
                                          label: "Año Académico:",
                                          options: _vm.filteredAcademicYears,
                                          placeholder: "Seleccione"
                                        },
                                        model: {
                                          value: _vm.model.academicYear,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.model,
                                              "academicYear",
                                              $$v
                                            )
                                          },
                                          expression: "model.academicYear"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-md flex-grow-1 d-flex align-items-center justify-content-end pr-md-4 pt-3"
                          },
                          [
                            _c("action-button", {
                              staticClass: "px-3 mr-2",
                              attrs: {
                                i: "fas fa-times-circle",
                                text: "Cancelar",
                                variant: "outline-danger"
                              },
                              on: { click: _vm.cancelEdit }
                            }),
                            _c("action-button", {
                              staticClass: "px-3",
                              attrs: {
                                i: "fas fa-arrow-alt-circle-right",
                                text: "Continuar",
                                variant: "success"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.academicYearNextHandler()
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _c(
                  "custom-collapse-item",
                  {
                    ref: _vm.accordionItems.goal.name,
                    staticClass: "border-bottom",
                    attrs: {
                      id: "collapse-item-goal",
                      "body-background-color": "#F7F7F7",
                      checked: _vm.accordionItems.goal.checked,
                      disabled: _vm.accordionItems.goal.disabled,
                      expanded: _vm.accordionItems.goal.expanded,
                      "parent-id": "meta-collapse",
                      selected: !_vm.accordionItems.goal.disabled,
                      title: "Metas"
                    }
                  },
                  [
                    _c("multi-selection-picker", {
                      attrs: {
                        "add-item-title-label":
                          "Añadir nueva Estrategia a su listado",
                        "all-items": _vm.catalog.goals,
                        "allow-item-list-editing": "",
                        "column-count": 1,
                        "edit-item-title-label":
                          "Editar Estrategia de su listado",
                        "id-prop-name": "id",
                        "item-type-name": "meta",
                        maxlength: "300",
                        "modify-removes-item": "",
                        placeholder: "Escriba aquí para buscar una",
                        "selected-items": _vm.catalog.addedGoals,
                        "text-prop-name": "name"
                      },
                      on: {
                        itemAdded: _vm.onAddedGoalHandler,
                        itemModified: _vm.onModifiedGoalHandler,
                        itemSelected: _vm.onSelectedGoalHandler
                      }
                    }),
                    _vm.catalog.addedGoals.length
                      ? _c("custom-chips-group", {
                          attrs: {
                            "no-background": "",
                            "no-wrap": "",
                            "object-text": "name",
                            "on-item-deleted": _vm.onDeleteGoalHandler,
                            "selected-items": _vm.catalog.addedGoals,
                            title: "Metas seleccionadas"
                          }
                        })
                      : _vm._e(),
                    _c("custom-error", {
                      attrs: {
                        "is-alert-mode": "",
                        message: "No se puede seleccionar más de una meta.",
                        variant: "mt-2 mb-0"
                      }
                    }),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col flex-grow-1 d-flex align-items-center justify-content-end pt-3"
                      },
                      [
                        _c("action-button", {
                          staticClass: "px-3 mr-2",
                          attrs: {
                            i: "fas fa-times-circle",
                            text: "Cancelar",
                            variant: "outline-danger"
                          },
                          on: { click: _vm.cancelEdit }
                        }),
                        _c("action-button", {
                          staticClass: "px-3",
                          attrs: {
                            i: "fas fa-arrow-alt-circle-right",
                            text: "Continuar",
                            variant: "success"
                          },
                          on: { click: _vm.goalNextHandler }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "custom-collapse-item",
                  {
                    ref: _vm.accordionItems.levelAchieved.name,
                    staticClass: "collapse-item",
                    attrs: {
                      id: "collapse-item-execution-level",
                      "body-background-color": "#F7F7F7",
                      checked: _vm.accordionItems.levelAchieved.checked,
                      disabled: _vm.accordionItems.levelAchieved.disabled,
                      expanded: _vm.accordionItems.levelAchieved.expanded,
                      "parent-id": "meta-collapse",
                      selected: !_vm.accordionItems.levelAchieved.disabled,
                      title: "Nivel de Ejecución Alcanzado"
                    }
                  },
                  [
                    _c(
                      "validation-observer",
                      { ref: "levelAchievedForm" },
                      [
                        _c("validation-provider", {
                          attrs: {
                            "custom-messages": {
                              required: "El nivel de ejecución es requerido"
                            },
                            rules: "required"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("execution-level-selector", {
                                    attrs: {
                                      error: errors[0],
                                      "execution-level-archieved":
                                        _vm.executionLevelArchieved
                                    },
                                    model: {
                                      value: _vm.model.executionLevelArchieved,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "executionLevelArchieved",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "model.executionLevelArchieved"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        }),
                        _c("div", { staticClass: "row mt-3 d-flex ml-n1" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-3" },
                            [
                              _vm.isExecutionLeveRequired
                                ? _c("validation-provider", {
                                    attrs: {
                                      "custom-messages": {
                                        required: "El porciento es requerido.",
                                        max_value: "El valor maximo es 100."
                                      },
                                      rules: `differentFromZero|max_value:100|${
                                        _vm.isExecutionLeveRequired
                                          ? "required|greaterThanZero"
                                          : ""
                                      }`
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({ errors }) {
                                            return [
                                              _c("custom-input", {
                                                attrs: {
                                                  error: errors[0],
                                                  label: "Porciento:",
                                                  type: "number"
                                                },
                                                model: {
                                                  value:
                                                    _vm.model
                                                      .executionLevelPercent,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "executionLevelPercent",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "model.executionLevelPercent"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3407441365
                                    )
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col flex-grow-1 d-flex align-items-center justify-content-end pt-3"
                            },
                            [
                              _c("action-button", {
                                staticClass: "px-3 mr-2",
                                attrs: {
                                  i: "fas fa-times-circle",
                                  text: "Cancelar",
                                  variant: "outline-danger"
                                },
                                on: { click: _vm.cancelEdit }
                              }),
                              _c("action-button", {
                                staticClass: "px-3",
                                attrs: {
                                  i: "fas fa-arrow-alt-circle-right",
                                  text: "Continuar",
                                  variant: "success"
                                },
                                on: { click: _vm.levelNextHandler }
                              })
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }